<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(139, 69, 19, 0.15), rgba(139, 69, 19, 0.25)); border-color: rgba(139, 69, 19, 0.4); color: #8B4513;">
          <i class="icon fire"></i>
          {{nokta ? 'Nokta Seçildi ✓' : 'Nokta Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Kaynak Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="kaynakAyarlariAcik = !kaynakAyarlariAcik">
        <i class="icon fire"></i>
        <span>Kaynak Tipi</span>
        <div class="chevron" [class.right]="!kaynakAyarlariAcik" [class.down]="kaynakAyarlariAcik"></div>
      </div>

      @if (kaynakAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Kaynak Tipi -->
        <div class="ayar-satir">
          <label>Tip:</label>
          <select [(ngModel)]="kaynakTipi" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (tip of kaynakTipleri; track tip.value) {
            <option [value]="tip.value">{{tip.label}}</option>
            }
          </select>
        </div>

        <!-- Pozisyon -->
        <div class="ayar-satir">
          <label>Pozisyon:</label>
          <select [(ngModel)]="pozisyon" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (poz of pozisyonlar; track poz.value) {
            <option [value]="poz.value">{{poz.label}}</option>
            }
          </select>
        </div>
      </div>
      }
    </div>

    <!-- Ölçü Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="olcuAyarlariAcik = !olcuAyarlariAcik">
        <i class="icon ruler"></i>
        <span>Ölçüler</span>
        <div class="chevron" [class.right]="!olcuAyarlariAcik" [class.down]="olcuAyarlariAcik"></div>
      </div>

      @if (olcuAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Boyut -->
        <div class="ayar-satir">
          <label>Boyut (mm):</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="0.5" min="1" max="50" />
          </div>
        </div>

        <!-- Uzunluk -->
        <div class="ayar-satir">
          <label>Uzunluk:</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" placeholder="0 = Sürekli"
                   style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="1" min="0" />
          </div>
        </div>

        <!-- Adet -->
        <div class="ayar-satir">
          <label>Adet:</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="adet" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" placeholder="0 = Yok"
                   style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="1" min="0" />
          </div>
        </div>

        <!-- Pitch (Aralık) -->
        <div class="ayar-satir">
          <label>Aralık:</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="pitch" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" placeholder="0 = Yok"
                   style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="1" min="0" />
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Sembol Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="sembolAyarlariAcik = !sembolAyarlariAcik">
        <i class="icon cog"></i>
        <span>Sembol Özellikleri</span>
        <div class="chevron" [class.right]="!sembolAyarlariAcik" [class.down]="sembolAyarlariAcik"></div>
      </div>

      @if (sembolAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Kontur -->
        <div class="ayar-satir">
          <label>Kontur:</label>
          <select [(ngModel)]="konturu" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (kontur of konturlar; track kontur.value) {
            <option [value]="kontur.value">{{kontur.label}}</option>
            }
          </select>
        </div>

        <!-- Tam Çevre -->
        <div class="ayar-satir">
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="tamCevre" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-checkbox" id="tamCevre" />
            <label for="tamCevre" class="checkbox-label">Tam Çevre (○)</label>
          </div>
        </div>

        <!-- Sahada Kaynak -->
        <div class="ayar-satir">
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sahadaKaynak" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-checkbox" id="sahadaKaynak" />
            <label for="sahadaKaynak" class="checkbox-label">Sahada Kaynak (🏴)</label>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyutFont" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyutFont}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutKaynak" class="catia-checkbox">
            <label for="sabitBoyutKaynak" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!nokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
